(function () {
    'use strict';

    angular.module("imApp").factory("stockTransferLoadItemService", ['$ihttp', 'p2DataTaskService', function ($ihttp, p2DataTaskService) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1038,
                    parameters: parms || {}
                });
            },
            listCorrectionCodes: function (parms) {
                return $ihttp.post({
                    method: 1071,
                    parameters: parms || {}
                });
            },
            scanStockTransferLoadItem: function (edit) {
                return p2DataTaskService.call(1060, edit);
			},
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1039,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
